module.exports = __webpack_public_path__ + "img/Jeremy.4b8a7937.jpg";